// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1mzPF","title":"AfterBackImages_title__3_tvR","images":"AfterBackImages_images__2Tqqm"};